import { render } from "./DashboardCreateCoupon.vue?vue&type=template&id=2397cf83&scoped=true"
import script from "./DashboardCreateCoupon.vue?vue&type=script&lang=js"
export * from "./DashboardCreateCoupon.vue?vue&type=script&lang=js"

import "./DashboardCreateCoupon.vue?vue&type=style&index=0&id=2397cf83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2397cf83"]])

export default __exports__